module.exports = __webpack_public_path__ + "static/media/Bioga.7f00f373.jpg";